import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="fullscreen"
export default class extends Controller {
  static targets = ["hideable"];

  toggle(e) {
    this.#toggleText(e.target);
    this.#toggleHideable();
    this.#updateUrl();
  }

  #toggleText(element) {
    const goToFull = element.dataset.goToFullText;
    const removeFull = element.dataset.removeFullText;

    if (element.innerText.toLowerCase() === goToFull.toLowerCase()) {
      element.innerText = removeFull;
    } else {
      element.innerText = goToFull;
    }
  }

  #toggleHideable() {
    this.hideableTargets.forEach((target) => target.classList.toggle("d-none"));
  }

  #updateUrl() {
    const query = new URLSearchParams(window.location.search);
    if (query.has("fullscreen")) {
      query.delete("fullscreen");
    } else {
      query.set("fullscreen", "1");
    }
    const queryParams = query.toString();

    const url = `${window.location.pathname}${
      queryParams === "" ? "" : `?${queryParams}`
    }`;

    history.replaceState(null, "", url);
  }
}
